/* TW · Shoppable hero + collection tiles (v4). Settings come from data- attributes on .tws (theme editor). */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(root){
    var hero = root.querySelector('.tws-hero'); if(!hero || hero.__tws) return; hero.__tws = true;
    var hots = [].slice.call(hero.querySelectorAll('.tws-hot'));
    var d = root.dataset;
    var cfg = { tips:d.tips||'hover', glimmer:d.glimmer!=='false', gap:+d.gap||3.6, sweep:+d.sweep||1.8,
                autoTip:d.autotip==='true', dots:d.dots!=='false', pulse:d.pulse==='true', mmode:d.mmode||'image' };
    var timer=null, idx=0, open=null;
    var phone = window.matchMedia('(max-width:749px)'), fine = window.matchMedia('(hover:hover) and (pointer:fine)');

    function visible(){ return hots.filter(function(h){ return getComputedStyle(h).display!=='none'; }); }
    function closeTip(){ if(open){ open.classList.remove('is-on'); open=null; } }
    function placeTip(tip){ tip.classList.remove('flip'); tip.style.marginLeft=''; var s=hero.getBoundingClientRect(), r=tip.getBoundingClientRect(); if(r.top<s.top+4){ tip.classList.add('flip'); r=tip.getBoundingClientRect(); } var dx=0; if(r.left<s.left+6) dx=s.left+6-r.left; else if(r.right>s.right-6) dx=s.right-6-r.right; if(dx) tip.style.marginLeft=dx+'px'; }
    function apply(){
      root.style.setProperty('--sweep', cfg.sweep+'s');
      root.classList.toggle('m-list', cfg.mmode==='image_list');
      root.classList.toggle('m-static', cfg.mmode==='static');
      var tips = cfg.tips; if(!fine.matches && tips==='hover') tips='tap';   // touch screens can't hover
      hero.className = 'tws-hero'+(cfg.dots?' dots-on':'')+(cfg.pulse?' pulse':'')+' tips-'+tips+(tips!=='off'?' hit':'');
      closeTip(); clearTimeout(timer); hots.forEach(function(h){ h.classList.remove('is-on'); });
      if(cfg.glimmer && !reduce && !(phone.matches && cfg.mmode==='static')) timer=setTimeout(loop,700);
    }
    function glimmer(){
      var vis=visible(); if(!vis.length) return true;
      var h=vis[idx%vis.length]; idx=(idx+1)%vis.length;
      void h.offsetWidth; h.classList.add('is-on'); setTimeout(function(){ h.classList.remove('is-on'); }, cfg.sweep*1000+100);
      if(cfg.autoTip){ var t=h.querySelector('.tws-tip'); closeTip(); placeTip(t); t.classList.add('is-on'); open=t; setTimeout(function(){ if(open===t) closeTip(); }, cfg.sweep*1000+900); }
      return idx===0;
    }
    function loop(){ clearTimeout(timer); var wrapped=glimmer(); timer=setTimeout(loop,(cfg.gap+(wrapped?2.4:0))*1000); }

    // tap mode: first tap shows the label, a tap on the label (or the dot again) opens the product
    hots.forEach(function(h){
      var dot=h.querySelector('.tws-dot'), tip=h.querySelector('.tws-tip');
      function openTip(e){ if(!hero.classList.contains('tips-tap')) return; if(open===tip) return; e.preventDefault(); closeTip(); placeTip(tip); tip.classList.add('is-on'); open=tip; }
      h.addEventListener('mouseenter',function(){ if(hero.classList.contains('tips-hover')) placeTip(tip); });
      dot.addEventListener('click',openTip);
      h.addEventListener('click',function(e){ if(e.target===dot||tip.contains(e.target)) return; if(hero.classList.contains('tips-tap')){ e.preventDefault(); openTip(e); } });
    });
    document.addEventListener('click',function(e){ if(open && !open.parentNode.contains(e.target)) closeTip(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeTip(); });
    [phone, fine].forEach(function(m){ if(m.addEventListener) m.addEventListener('change',apply); });
    root.__twsApply = function(next){ for(var k in next) cfg[k]=next[k]; apply(); };   // used by the preview page
    apply();
  }

  // falling snowflakes over a tile (effect: snow)
  function initSnow(canvas){
    if(canvas.__tws || reduce) return; canvas.__tws = true;
    var ctx=canvas.getContext('2d'), flakes=[], w=0, h=0, dpr=Math.min(window.devicePixelRatio||1,2), running=false, raf=0;
    var amount=Math.max(10,Math.min(300,+canvas.getAttribute('data-amount')||180));   // tile setting "Snowflakes", per 300×300 px of tile
    function size(){ var r=canvas.getBoundingClientRect(); w=r.width; h=r.height; canvas.width=w*dpr; canvas.height=h*dpr; ctx.setTransform(dpr,0,0,dpr,0,0); }
    function make(top){ var k=Math.random(), big=k>.9, mid=k>.6;   // mostly fine flakes, some medium, a few big soft ones up front
      return { x:Math.random()*w, y:top?Math.random()*h:-8, r:big?3+Math.random()*2.2:mid?1.8+Math.random()*1.2:.8+Math.random()*1, s:big?.9+Math.random()*.6:mid?.55+Math.random()*.5:.3+Math.random()*.35, a:Math.random()*Math.PI*2, o:big?.9:mid?.8:.55+Math.random()*.3, b:big?8:4 }; }
    function frame(){
      ctx.clearRect(0,0,w,h);
      for(var i=0;i<flakes.length;i++){ var f=flakes[i]; f.a+=.012; f.y+=f.s; f.x+=Math.sin(f.a)*.4;
        if(f.y>h+8){ flakes[i]=make(false); continue; }
        ctx.beginPath(); ctx.fillStyle='rgba(255,255,255,'+f.o+')'; ctx.shadowColor='rgba(40,62,92,.6)'; ctx.shadowBlur=f.b*.6; /* cool-grey halo keeps white flakes visible on white photos */ ctx.arc(f.x,f.y,f.r,0,Math.PI*2); ctx.fill(); }
      raf=requestAnimationFrame(frame);
    }
    function start(){ if(running) return; running=true; size(); if(!flakes.length){ var n=Math.round(amount*(w*h)/90000); for(var i=0;i<Math.min(Math.max(n,20),400);i++) flakes.push(make(true)); } frame(); }
    function stop(){ running=false; cancelAnimationFrame(raf); }
    if('IntersectionObserver' in window){ new IntersectionObserver(function(es){ es[0].isIntersecting?start():stop(); }).observe(canvas); } else start();
    window.addEventListener('resize',function(){ if(running) size(); });
  }

  function init(scope){
    [].slice.call((scope||document).querySelectorAll('.tws')).forEach(initHero);
    [].slice.call((scope||document).querySelectorAll('.tws-snow')).forEach(initSnow);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ init(); }); else init();
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });   // theme editor live preview
})();
